// ABOUTME: Buckets dashboard items into display groups by their first tag.
// ABOUTME: Pure and structurally typed — the stored position model is untouched.
export interface ItemGroup<T> {
  /** null is the unlabeled group, rendered with no heading. */
  tag: string | null;
  items: T[];
}

export function groupItems<T extends { tags?: string[] }>(items: T[]): ItemGroup<T>[] {
  const untagged: T[] = [];
  const byTagKey = new Map<string, { display: string; items: T[] }>();

  for (const item of items) {
    const tag = item.tags
      ?.filter((t): t is string => typeof t === "string")
      .map((t) => t.trim())
      .find((t) => t.length > 0);
    if (!tag) {
      untagged.push(item);
      continue;
    }
    const key = tag.toLowerCase();
    const bucket = byTagKey.get(key);
    if (bucket) bucket.items.push(item);
    else byTagKey.set(key, { display: tag, items: [item] });
  }

  const groups: ItemGroup<T>[] = [];
  if (untagged.length) groups.push({ tag: null, items: untagged });
  for (const { display, items: tagged } of byTagKey.values())
    groups.push({ tag: display, items: tagged });
  return groups;
}

export function collapseKey(userId: string | null): string {
  return `dashboard_collapsed_${userId ?? "guest"}`;
}

export function readCollapsed(userId: string | null): Set<string> {
  try {
    const raw = localStorage.getItem(collapseKey(userId));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? new Set(parsed.filter((t) => typeof t === "string")) : new Set();
  } catch {
    return new Set();
  }
}

export function writeCollapsed(userId: string | null, collapsed: Set<string>): void {
  try {
    localStorage.setItem(collapseKey(userId), JSON.stringify([...collapsed]));
  } catch {
    // Collapse state is a convenience; losing it is not worth surfacing.
  }
}
